import { CircularProgress, Stack, Typography } from '@mui/material';
import { AccessEventsFilter } from 'graphql/generated/graphqlTypes';
import useExportAccessEvents from 'hooks/useExportAccessEvents/useExportAccessEvents';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useEffect } from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import useModalContext from 'v2/components/Modal/useModalContext';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';

interface Props {
  filter: AccessEventsFilter | null;
}

const PreparingExportModal: React.FC<Props> = ({ filter }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();
  const { showSnackbar } = useSnackbarContext();

  const { startDownloadingAccessEventsToFile, abortDownloadingAccessEventsToFile, isDownloadDone } =
    useExportAccessEvents({
      handleFetchError: (msg) => showSnackbar(msg, { severity: 'error' })
    });

  useEffect(() => {
    startDownloadingAccessEventsToFile(filter);
  }, []);

  useEffect(() => {
    if (isDownloadDone) closeModal();
  }, [isDownloadDone, closeModal]);

  const handleAbort = () => {
    abortDownloadingAccessEventsToFile();
    closeModal();
  };

  return (
    <ModalTemplate
      title={translation.preparing_your_export}
      secondaryAction={{ id: 'cancel-export-button', label: translation.cancel, onClick: handleAbort }}
    >
      <Stack alignItems="center" spacing={2} py={2} gap={2} direction="row">
        {/* div: otherwise flexbox will mess with the animation */}
        <div>
          <CircularProgress size={48} />
        </div>
        <Typography variant="body1">{`${translation.export_preparing_notice}.`}</Typography>
      </Stack>
    </ModalTemplate>
  );
};

export default PreparingExportModal;
